import {
  FETCH_TRANSACTION_SUMMARY_REQUEST,
  FETCH_TRANSACTION_SUMMARY_SUCCESS,
  FETCH_TRANSACTION_SUMMARY_ERROR,
  FETCH_TRANSACTION_LIST_REQUEST,
  FETCH_TRANSACTION_LIST_SUCCESS,
  FETCH_TRANSACTION_LIST_ERROR,
} from './actions';

const initialState = {
  summary: {
    data: null,
    loading: false,
    error: null,
  },
  list: {
    data: null,
    loading: false,
    error: null,
  },
};

/**
 * Transform transaction results to use camelCase naming convention.
 * Maps snake_case API fields to camelCase for frontend consistency.
 * 
 * @param {Object} data - Raw API response with results array
 * @returns {Object} - Transformed data with camelCase field names
 */
function transformTransactionResults(data) {
  if (!data || !data.results) {
    return data;
  }
  
  return {
    ...data,
    results: data.results.map(transaction => ({
      ...transaction,
      // Transform merchant_name to businessName (following frontend convention)
      // merchant_name is now enriched from TerraBE's account_business_name
      businessName: transaction.merchant_name || transaction.business_name || '',
      // Keep merchant_name for backwards compatibility
    })),
  };
}

export function transactionReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TRANSACTION_SUMMARY_REQUEST:
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          error: null,
        },
      };
    case FETCH_TRANSACTION_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case FETCH_TRANSACTION_SUMMARY_ERROR:
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          error: action.payload,
        },
      };
    case FETCH_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
        },
      };
    case FETCH_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        list: {
          data: transformTransactionResults(action.payload),
          loading: false,
          error: null,
        },
      };
    case FETCH_TRANSACTION_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
}
